<template>
    <div class="promotions__item">
        <div class="promotions__item-wrapper">
            <img
                class="promotions__item-image"
                :src="promotion.image"
                :alt="promotion.title"
            />
            <div
                v-if="promotion.badges.length > 0"
                class="promotions__item-badges"
            >
                <SdsBadge
                    v-for="(badge, index) in promotion.badges"
                    :key="index"
                    background="color"
                    variant="primary"
                    styling="neutral"
                    size="lg"
                    shape="pill"
                    class="promotions__item-badge"
                >
                    {{ badge }}
                </SdsBadge>
            </div>
            <div class="promotions__item-overlay-wrapper"></div>
            <div class="promotions__item-overlay">
                <div class="promotions__item-details">
                    <div class="promotions__item-title">
                        {{ promotion.title }}
                    </div>
                    <span class="promotions__item-subtitle">
                        {{ promotion.description }}
                    </span>
                    <PromotionLink
                        v-if="promotion.link && promotion.linkText"
                        :link="promotion.link"
                    >
                        {{ promotion.linkText }}
                    </PromotionLink>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import PromotionLink from '@app/promotions/components/PromotionLink';
    import { SdsBadge } from '@superbet-group/web.lib.ui-components';

    export default {
        props: {
            promotion: {
                type: Object,
                required: true,
            },
        },
        components: {
            PromotionLink,
            SdsBadge,
        },
    };
</script>
